<template>
    <div>
        <v-toolbar
		dark
		fixed
		app
		height="50"
		class="toolBar"
		>
		<v-spacer></v-spacer>
        <v-toolbar-items>
			<v-icon class="white--text" @click="downloadWithCSS('Training-Information-Detail-Report')">cloud_download</v-icon>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
			<v-icon class="white--text" @click="printdiv">print</v-icon>
		</v-toolbar-items>
        </v-toolbar>

        <v-container grid-list-md :class="{opacityC:isTrue}">
      <v-layout wrap>
        <v-flex xs10 offset-xs1>
          <div style="background:#FFF; padding:20px;">
			<div ref="content" id="print_div">		
                <table class="reportTbl" width="100%" id="tblData" >
					<tbody>
                        <tr class="tb-td">
							<td colspan="8">Investment Promotion & Financing Facility II (IPFF II) Project</td>
						</tr>
						<tr class="tb-td">
							<td colspan="8">International Development Association</td>
						</tr>
						<tr class="tb-td">
							<td colspan="8"></td>
						</tr>
						<tr class="tb-td">
							<td colspan="8">Bangladesh Bank, Head Office , Dhaka</td>
						</tr>
						<tr class="tb-td">
							<td colspan="8"></td>
						</tr>

                        <tr>
                            <td><b>SL</b></td>
							<td><b>Category</b></td>
							<td><b>Year</b></td>
							<td><b>Training Title</b></td>
							<td><b>Duration</b></td>
                            <td><b>Venue</b></td>
							<td><b>Organizer</b></td>
							<td><b>Total Participants</b></td>
						</tr>
						<tr v-for="(item,index) in items" :key="index">
							<td>{{++index}}</td>
							<td>{{item.training_cat}}</td>
							<td>{{item.start_date.substr(0,4)}}</td>
							<td>{{item.training_title}}</td>
							<td>{{item.duration}}</td>
							<td>{{item.venue}}</td>
							<td>{{item.credit_name}}</td>
							<td>{{item.total_participant}}</td>
						</tr>
		
					</tbody>
                </table>		
			</div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    </div>
</template>
<script>
import jsPDF from "jspdf";
import html2canvas from "html2canvas"
const commonService = require("../../../services/common.service");
export default {
    props:['paramVal'],
    data: () => ({
		
		items:[],
		subItems:[],
		isTrue:false,
		
	}),
    	created(){		
		//console.log('created');
		this.getData();
	},

	watch: {
        paramVal() {
            console.log(this.paramVal)
        	this.getData();
        }
    },

	methods: {

		getData(){

			let root = this;
			let formSchema = '';
			let p = this.paramVal;
			
			if(typeof p == "undefined")
			{
				this.isTrue = false;
				formSchema = JSON.parse(sessionStorage.getItem('report'));
			}
			else
			{
				this.isTrue = true;
				formSchema = this.paramVal;
			}
			
			/*let formSchema = {
				'project_id': 1,
				'report_type': 1,
			}*/

			commonService.dataByMulParameters(formSchema, "training-info-detail-report").then(res => {

				if(res)
				{
					if(res.mainQueryData.length>0)
					{
						this.items = res.mainQueryData
						
					}


					if(formSchema.report_type == 0)
					{	
						setTimeout(function(){							
							root.exportTableToExcel('tblData', 'Training-Information-Report');
						},1000);							
					}					
				}

			});
		},


	downloadWithCSS(filename='') 
		{
	       var quotes = document.getElementById('print_div');
	       html2canvas(quotes).then((canvas) => {
	            //! MAKE YOUR PDF
	            var pdf = new jsPDF('p', 'pt', 'letter');	  


	            for (var i = 0; i <= quotes.clientHeight/980; i++) {
	                //! This is all just html2canvas stuff
	                var srcImg  = canvas;
	                var sX      = 0;
	                var sY      = 1150*i; // start 980 pixels down for every new page
	                var sWidth  = 1150;
	                var sHeight = 1350;
	                var dX      = 25;
	                var dY      = 25;
	                var dWidth  = 1150;
	                var dHeight = 1350;

	                /*var sX      = 0;
	                var sY      = 980*i; // start 980 pixels down for every new page
	                var sWidth  = 900;
	                var sHeight = 1000;
	                var dX      = 0;
	                var dY      = 0;
	                var dWidth  = 900;
	                var dHeight = 980;*/

	                window.onePageCanvas = document.createElement("canvas");
	                onePageCanvas.setAttribute('width', 1150);
	                onePageCanvas.setAttribute('height', 1350);
	                var ctx = onePageCanvas.getContext('2d');
	                // details on this usage of this function: 
	                // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Using_images#Slicing
	                
	                ctx.drawImage(srcImg,sX,sY,sWidth,sHeight,dX,dY,dWidth,dHeight);

	                // document.body.appendChild(canvas);
	                var canvasDataURL = onePageCanvas.toDataURL("image/png", 1.0);

	                var width         = onePageCanvas.width;
	                var height        = onePageCanvas.clientHeight;

	                //! If we're on anything other than the first page,
	                // add another page
	                if (i > 0) {
	                    pdf.addPage(); //8.5" x 11" in pts (in*72)
	                }
	                //! now we declare that we're working on that page
	                pdf.setPage(i+1);
	                //! now we add content to that page!
	                pdf.addImage(canvasDataURL, 'PNG', 20, 40, (width*.62), (height*.62));

	            }
	            //! after the for loop is finished running, we save the pdf.
	            pdf.save('Training-Information-Detail-Report.pdf');
	        });      
	    },




	printdiv: function () {
                this.printContentStatus = true;
                const divToPrint = document.getElementById("print_div");
                this.printContentStatus = false;
                const newWin = window.open("", "Print-Window");
                newWin.document.open();
                newWin.document.write(
                    '<style type="text/css">'+
                    'table.reportTbl{width:100%;border-collapse:collapse}.reportTbl td{border:1px solid #ccc;padding:6px}.reportTbl tr td{text-align:left;line-height:15px}.txtRight{text-align:right!important}.reportTbl tr.txtCenter td{text-align:center}.reportTbl tr.tb-td td{font-weight:700;text-align:center;border:none}td.textCenter{text-align:center!important}td.textRight{text-align:right !important}'+
                    "</style>"
                );
                newWin.document.write(
                    '<html><head><link rel="stylesheet" href="src/assets/css/style.css" type="text/css" /></head><body onload="window.print()">' +
                    divToPrint.innerHTML +
                    "</body></html>"
                );

                newWin.document.close();
                setTimeout(function () {
                    newWin.close();
                }, 10);
            },

}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
table.reportTbl{
	width:100%;
	border-collapse: collapse;
}
.reportTbl td{
	border:1px solid #CCC;
	padding: 6px;
}
.reportTbl tr td{	
	text-align:left;
	line-height: 15px;
}
.txtRight{	
	text-align:right !important;
}
.reportTbl tr.txtCenter td{	
	text-align:center;
}
.reportTbl tr.tb-td td{
	font-weight: bold;
	text-align:center;
	border:none;
}
td.textCenter{
	text-align: center !important;
}
td.textRight{
	text-align: right !important;
}
.text-center{
    text-align: center !important;
}
.text-bold{
    font-weight: bold;
	text-align:center;
}
</style>


// WEBPACK FOOTER //
// src/components/reportGenerate/pdf/trainingInformationDetailReport.vue